var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackMoney1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 179,
    viewBox: "0 0 150 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1595_5313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5958 13.1416L45.4362 62.926H0L27.5958 13.1416Z",
    fill: "#00000027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4891 13.597L54.4309 54.2001L37.8137 7.90625H78.5959L82.4891 13.597Z",
    fill: "#00000027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.715 62.9258H62.2845L89.5 23.6875L116.715 62.9258Z",
    fill: "#00000027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.186 7.90625L124.644 54.2001L96.5109 13.597L100.404 7.90625H141.186Z",
    fill: "#00000027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 62.926H133.638L151.479 13.1416L179 62.926Z",
    fill: "#00000027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.391 171.989L83.0187 170.318L1.6781 74.3145H49.4786L83.3991 169.177L84.391 171.989Z",
    fill: "#00000027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.402 74.3145L89.5 152.254L61.5984 74.3145H117.402Z",
    fill: "#00000027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.322 74.3145L95.9813 170.318L94.609 171.914L95.5189 169.259L129.521 74.3145H177.322Z",
    fill: "#00000027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1595_5313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 179,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackMoney1);
export default __webpack_public_path__ + "static/media/backMoney1.8c752d415f31ec8a3c150bec3d50f935.svg";
export { ForwardRef as ReactComponent };